module.exports = __webpack_public_path__ + "img/loginArrow.b4ff6ae9.svg";